"use client"

type CalendarProviderLike = {
  provider?: string
  is_google?: boolean
}

type InviteMessageArgs = {
  mode: "create" | "edit"
  sendInvites?: boolean
  supportsInviteMessage: boolean
  includeInviteMessage?: boolean
  inviteMessage?: string
}

export const supportsCustomInviteMessage = (provider?: CalendarProviderLike | null) => {
  return provider?.is_google !== true && provider?.provider !== "google"
}

export const appendSignatureIfMissing = (content: string | undefined, signature: string) => {
  const body = (content ?? "").replace(/\r\n/g, "\n").trimEnd()
  const normalizedSignature = signature.replace(/\r\n/g, "\n").trim()
  if (!normalizedSignature) return body
  if (body.endsWith(normalizedSignature)) return body
  return body ? `${body}\n\n${normalizedSignature}` : normalizedSignature
}

export const resolveInviteMessageForSubmission = ({
  mode,
  sendInvites,
  supportsInviteMessage,
  includeInviteMessage,
  inviteMessage,
}: InviteMessageArgs) => {
  if (!sendInvites || !supportsInviteMessage || !includeInviteMessage) return undefined

  const trimmed = inviteMessage?.trim()
  if (!trimmed) return mode === "create" ? "" : undefined
  return trimmed
}

export const requiresInviteMessage = ({
  sendInvites,
  supportsInviteMessage,
  includeInviteMessage,
  inviteMessage,
}: Omit<InviteMessageArgs, "mode">) => {
  return Boolean(sendInvites && supportsInviteMessage && includeInviteMessage && !inviteMessage?.trim())
}
